module.exports = __webpack_public_path__ + "static/media/background3.63637b5a.jpg";